import { ResetPasswordState } from "./types";

export const CLASSNAME_TEXTFIELD = "text-regular h-[37px] pl-[14px] pb-[4px] mt-0 rounded-[6px]";

export const INITIAL_RESET_PASSWORD_STATE: ResetPasswordState = {
	username: "",
	password: "",
	passwordStrength: "",
	code: "",
	someEmptyField: true,
	remember: false,
	showPassword: false,
	error: false,
	visible: false,
	isLoading: false,
	message: "The username or password you entered is incorrect.",
	validForm: false,
	passwordConfirm: "",
	showPasswordConfirm: false,
	visibleConfirm: false,
};
